import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    repaymentsOverMonths: {
        id: '_.draw_down.choose_amount.your_repayments_over_months',
        defaultMessage: 'Your repayments over {months} months'
    },
    myRepaymentSchedule: {
        id: '_.draw_down.choose_amount.my_repayment_schedule',
        defaultMessage: 'See my repayment schedule'
    },
    monthlyRepaymentLabel: {
        id: '_.draw_down.choose_amount.monthly_repayment',
        defaultMessage: 'Minimum monthly repayment'
    },
    interestRateLabel: {
        id: '_.draw_down.choose_amount.interest_rate_label',
        defaultMessage: 'Interest rate'
    },
    interestRatePeriod: {
        id: '_.draw_down.choose_amount.interest_rate_period',
        defaultMessage: 'per 30 days'
    },
    interestOnlyMonthlyRepaymentLabel: {
        id: '_.draw_down.choose_amount.interest_only_monthly_repayment',
        defaultMessage: 'Minimum monthly repayment (months 4 - 15)'
    },
    interestOnlySubtitle: {
        id: '_.draw_down.choose_amount.interest_only_subtitle',
        defaultMessage: '(includes 3 months interest-only)'
    },
    totalInterestLabel: {
        id: '_.draw_down.choose_amount.total_interest',
        defaultMessage: 'Total interest'
    },
    feesLabel: {
        id: '_.draw_down.choose_amount.fees',
        defaultMessage: 'Fees'
    },
    feesAlways: {
        id: '_.draw_down.choose_amount.always',
        defaultMessage: 'always'
    },
    totalRepaymentLabel: {
        id: '_.draw_down.choose_amount.total_repayment',
        defaultMessage: 'Total repayment'
    },
    earlyRepaymentLinkLabel: {
        id: '_.draw_down.choose_amount.early_repayment_label',
        defaultMessage: 'Interested in repaying early?'
    },
    earlyRepaymentLinkText: {
        id: '_.draw_down.choose_amount.early_repayment_text',
        defaultMessage: 'See how it could look'
    },
    discountedOffer: {
        id: '_.draw_down_.discountedOffer',
        defaultMessage: 'Our offer for you:'
    }
});
